import React from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ExercisePlayer from './components/ExercisePlayer';
import Tabs from './components/PlayerTabs';
import ExercisePlayerStress from './components/ExercisePlayerStress';

const CardExercise = ({exercise, l2, exerciseHandler}) => {
  const [showInfo, setShowInfo] = useState(false);
  const [dia, setDia] = useState(null);
  const tabsData = [  
    {label: 'Oslo'},
    {label: 'Elverum'},
    {label: 'Trondheim'},
    {label: 'Malm'},
    {label: 'Stavanger'},
    {label: 'Bergen'},
    {label: 'Sandnessjøen'},
    {label: 'Tromsø'},
];
  const [tabs, setTabs] = useState(tabsData)   
  useEffect(()=>{
    if (l2 === "Norwegian") {
    const tabsData = [  
                        {label: 'Oslo'},
                        {label: 'Elverum'},
                        {label: 'Trondheim'},
                        {label: 'Malm'},
                        {label: 'Stavanger'},
                        {label: 'Bergen'},
                        {label: 'Sandnessjøen'},
                        {label: 'Tromsø'},
                    ];
    fetch(`${process.env.REACT_APP_API_URL}/norwegian/exercise/${exercise.id}`)
        .then(response=>response.json())
            .then(json=>{
                let info_json = {"name": json.Exercise_name, "group": json.Group_lesson, "type": json.Type_description}
                
                var dialects = [];
                var tab_dialect = []
                for ( const dia of tabsData) {
                    var dialect = []
                    for (const lang of json.MP_wordpairs) {
                        if (lang[0]['audio_'+dia.label].length > 0 && lang[1]['audio_'+dia.label].length > 0)
                        {

                        dialect.push({"pair_0":{"track_0":lang[0]['audio_'+dia.label], "word": lang[0].word, "translation": lang[0].Translation[lang[0].Translation_description.findIndex(x => x ==='en')] }, "pair_1":{"track_0":lang[1]['audio_'+dia.label],  "word": lang[1].word, "translation": lang[1].Translation[lang[1].Translation_description.findIndex(x => x ==='en')]}})
                        }
                    }

                    if (dialect.length > 4)
                    {
                        tab_dialect.push(dia)
                        dialects.push(dialect)
                    }
                    
                    
                }
                
                setTabs(tab_dialect) 
                setDia(tab_dialect[0])   

                 })
                }
             
},[exercise.id,l2]) 



    if(l2 === "Norwegian") {
      return <div className='flex flex-col'>

                  
                  
                  
                  <div className='mx-auto flex flex-row border-2 border-gray-200 shadow-xl p-5 rounded-md  mt-5 scale-75 md:scale-100'>


                    <div className="mr-3 py-10  flex items-center scale-75 md:scale-100">
                          <Tabs 
                              clickHandler={(tab_index) =>
                                      {
                                          
                                          setDia(tabs[tab_index]);
                                        
                                    
                                      }
                              } 
                              tabsData={tabs} 
                          />
                    </div>


                  
                    <div className='flex flex-col h-full md:h-auto'>
                 
                    <div className={`grow
                  ${showInfo ? 'opacity-0 h-0' : 'opacity-100 h-full'} `}
                >
                    
                    {dia && <ExercisePlayer dialect={dia} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler} />}
                    
                      </div>
                   
                </div>
 
                </div></div>
    }
        return <div className='md:flex md:flex-col items-center justify-center mx-auto h-screen md:py-0'> 
            
        {/*The card*/}
        <div className={`h-full md:h-auto w-full xl:w-3/5  shadow md:mx-auto md:flex md:flex-col md:rounded-3xl bg-gray-50 md:py-3 animate__animated
        `}> 
        
          
          {/* Main body */}
          <div className='flex flex-col h-full md:h-auto'>
          
              <div className={`flex flex-col
                    ${showInfo ? 'opacity-0 h-0' : 'opacity-100 h-full'} `}
                  >

                    {/* three cases -- two stress exercises and just exercise */}
                  
                    {exercise.Exercise_name === 'first-second-third' ? 
                    <ExercisePlayerStress numStress={3} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler}/>
                    :
                    exercise.Exercise_name === 'first-second' ? 
                    <ExercisePlayerStress numStress={2} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler} />
                    :
                    <ExercisePlayer id={exercise.id} l2={l2} exerciseHandler={exerciseHandler}/>
                    }
              <div/>    
          
            </div>
          </div>    
        </div>
      </div> 

    
}
export default CardExercise;
